/* unplugin-vue-components disabled */import { render } from "./LoaderComponent.vue?vue&type=template&id=2569e804&scoped=true"
import script from "./LoaderComponent.vue?vue&type=script&lang=js"
export * from "./LoaderComponent.vue?vue&type=script&lang=js"

import "./LoaderComponent.vue?vue&type=style&index=0&id=2569e804&scoped=true&lang=css"
import "./LoaderComponent.vue?vue&type=style&index=1&id=2569e804&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2569e804"]])

export default __exports__